import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { lenis } from './lenis'

gsap.registerPlugin(ScrollTrigger)

export const initSprig = () => {
 
	let el = document.querySelector('[data-sprig-container]')
	let entries = document.querySelector('[data-sprig-entries]')

	if (!el || !entries) return

	htmx.on('htmx:beforeRequest', (e) => {
		el = document.querySelector('[data-sprig-container]')
		entries = document.querySelector('[data-sprig-entries]')

		gsap.to(entries, {
			duration: 0.35,
			opacity: 0,
			onComplete: () => {
			}
		})

		if (!el.hasAttribute('data-sprig-prevent-scroll')) {
			lenis.scrollTo(el, {
				duration: 1.5,
				offset: -100
			})
		} else {
			console.log('Scroll prevented by data-sprig-prevent-scroll attribute')
		}
	})

	htmx.on('htmx:afterSwap', () => {
		el = document.querySelector('[data-sprig-container]')
		entries = document.querySelector('[data-sprig-entries]')

		gsap.fromTo(entries, {
			opacity: 0
		}, {
			opacity: 1,
			duration: 0.35
		})
	})
}

export default () => {} 